<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/goods' }">产品列表</el-breadcrumb-item>
            <el-breadcrumb-item>创建产品</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <div style="width:80%">
        <el-form :model="form" label-width="120px">
            <el-form-item label="名称">
                <el-input v-model="form.title" maxlength="150" show-word-limit/>
            </el-form-item>
            <el-form-item label="封面图">
              <el-row class="martop">
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :http-request="uploadImg"
                  :show-file-list="false"
                >
                  <img v-if="form.img" :src="form.img" class="avatar" />
                  <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
                </el-upload>
              </el-row>
            </el-form-item>
            <el-form-item label="所属公司">
                <el-select
                    v-model="form.companyid"
                    placeholder="请选择"
                    >
                    <el-option
                        v-for="item in baseData.companylist"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="分类名称">
                <el-cascader
                    v-model="form.cates"
                    :options="baseData.cateslist"
                    :props="propss"
                    clearable
                    @change="handleChange"
                />
            </el-form-item>
            <el-form-item label="轮播图">
                <el-upload
                    v-model:file-list="form.imglist"
                    action=""
                    :http-request="uploadImgList"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                >
                    <el-icon><Plus /></el-icon>
                    <template #tip>
                        <div class="el-upload__tip">
                          请上传jpg/png的统一尺寸图片，图片比例为3:4，推荐尺寸：390px*520px,图片大小不能大于6M
                        </div>
                      </template>
                </el-upload>
    
                <el-dialog v-model="dialogVisible">
                    <img w-full :src="dialogImageUrl" alt="Preview Image" />
                </el-dialog>
            </el-form-item>
            <el-form-item label="简介" style="width: 100%">
                <el-input type="textarea" v-model="form.introduction" maxlength="250" show-word-limit/>
            </el-form-item>
            <el-form-item label="公司详情图">
                <el-upload
                    v-model:file-list="form.detailimglist"
                    action=""
                    :http-request="uploadDetailImg"
                    list-type="picture-card"
                    :on-preview="handleDetailPictureCardPreview"
                    :on-remove="handleDetailRemove"
                >
                    <el-icon><Plus /></el-icon>
                    <template #tip>
                        <div class="el-upload__tip">
                          请上传jpg/png的统一尺寸图片，图片比例为1:2，推荐尺寸：350px*700px,图片大小不能大于10M
                        </div>
                      </template>
                </el-upload>
    
                <el-dialog v-model="dialogDetailVisible">
                    <img w-full :src="dialogDetailImageUrl" alt="Preview Image" />
                </el-dialog>
            </el-form-item>
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio label="0">冻结</el-radio>
                <el-radio label="1">待审核</el-radio>
                <el-radio label="2">正常</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="goBack">返回</el-button>
            </el-form-item>
        </el-form>
      </div>
    </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted, ref } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading, UploadProps, UploadUserFile } from 'element-plus'
  import {useRouter, useRoute} from 'vue-router'

  const router = useRouter()
  const route = useRoute()
  const baseData:any = reactive({
    loading: false,
    cateslist: [],
    memberlist: [],
    companylist: [],
  })
  const propss = {
    expandTrigger: 'hover' as const,
    value:'id',
    label:'title',
    children:'children',
  }
  const form = reactive({
    id: '',
    cid:'',
    img:'',
    companyid:'',
    cates: [],
    imglist: [],
    detailimglist: [],
    title:'',
    introduction: '',
    status: true,
  })
  const dialogImageUrl = ref('')
  const dialogVisible = ref(false)
  const dialogAboutImageUrl = ref('')
  const dialogAboutVisible = ref(false)
  const dialogDetailImageUrl = ref('')
  const dialogDetailVisible = ref(false)
  const getCatesList = () => {
    baseData.loading = true
    api.goodsApi.get_cates_list({limit:1000,page:1}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.cateslist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getCompanyList = () => {
    baseData.loading = true
    api.companyApi.list({limit:1000,page:1}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.companylist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const handleChange = (value:any) => {
    form.cid = value[value.length - 1]
  }
  const onSubmit = () => {
    const loading = ElLoading.service({lock: true})
    var data:any = {
      cid: form.cid,
      companyid: form.companyid,
      cates: form.cates.join(','),
      img: form.img,
      imglist: form.imglist ? JSON.stringify(form.imglist) : "",
      detailimglist: form.detailimglist ? JSON.stringify(form.detailimglist) : "",
      title: form.title,
      introduction: form.introduction,
      status: form.status
    }
    api.goodsApi.add(data).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/goods");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const goBack = () => {
    router.go(-1);
  }
  
  const uploadImg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const uploadImgList = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过6MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
          let data:any = {name:file.name,url:res.data.img}
          form.imglist.pop()
          form.imglist.push(data);
        }
    })
  }
  const uploadDetailImg = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过10MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
        let data:any = {name:file.name,url:res.data.img}
        form.detailimglist.pop()
        form.detailimglist.push(data);
        }
    })
  }
  const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogImageUrl.value = uploadFile.url!
    dialogVisible.value = true
  }
  const handleDetailRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handleDetailPictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogDetailImageUrl.value = uploadFile.url!
    dialogDetailVisible.value = true
  }
  onMounted(() => {
    getCatesList()
    getCompanyList()
  })
  </script>